import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-document-dialog',
  templateUrl: './document-dialog.component.html',
  styleUrl: './document-dialog.component.css'
})
export class DocumentDialogComponent {
docForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DocumentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.docForm = this.fb.group({
      doc_name: ['', Validators.required],
      file: ['', Validators.required],
      file_name: ['']
    });
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    
    if (file) {
      this.docForm.patchValue({
        file: file,
        file_name: file.name
      });
    }
  }

  save(): void {
    if (this.docForm.valid) {
      this.dialogRef.close(this.docForm.value);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}